import { ReduxAction } from '@repo/utils/types';

type HTTPVerb = 'fetchAll' | 'fetch' | 'create' | 'update' | 'delete' | 'merge' | 'restore';
type RequestState = 'Requested' | 'Succeeded' | 'Failed';
type ActionCreatorKey<T extends HTTPVerb> = T | `${Extract<T, string>}${RequestState}`;
export type ActionCreators<T extends HTTPVerb> = {
  [key in ActionCreatorKey<T>]: (payload?: any) => ReduxAction;
};

// object of action creators keyed by httpVerb + requestState. requestState is excluded for actions that can effect the
// redux store immediately and may or may not have associated HTTP requests dispatched asyncronously
export function requestActions<T extends HTTPVerb>(
  resourceType: string,
  httpVerbs: HTTPVerb[] = ['fetchAll', 'fetch', 'create', 'update', 'delete', 'restore'],
): ActionCreators<T> {
  return httpVerbs.reduce((actionCreators: ActionCreators<T>, verb: HTTPVerb) => {
    // "Requested" is included here for handling the case where a request is not dispatched immediately
    // in response to an action, e.g. autosave
    return ([null, 'Requested', 'Succeeded', 'Failed'] as RequestState[]).reduce(
      (actionCreators: ActionCreators<T>, requestState: RequestState) => {
        const key = requestState
          ? (`${verb}${requestState}` as ActionCreatorKey<T>)
          : (verb as ActionCreatorKey<T>);
        const snakeCasedVerb = verb != 'fetchAll' ? verb : 'fetch_all';
        let actionType = `${snakeCasedVerb.toUpperCase()}_${resourceType.toUpperCase()}`;

        // pluralize resourceType for fetchAll action
        if (verb == 'fetchAll' && !['ACTIVITY'].includes(resourceType)) {
          actionType = `${actionType}S`;
        }

        if (requestState) {
          actionType = `${actionType}_${requestState.toUpperCase()}`;
        }

        const action: ReduxAction = { type: actionType };

        if (requestState == 'Failed') {
          action.error = true;
        }

        actionCreators[key] = (payload: any) => ({ ...action, payload });

        return actionCreators;
      },
      actionCreators,
    );
  }, {} as ActionCreators<T>);
}

// type HTTPVerb = 'fetchAll' | 'fetch' | 'create' | 'update' | 'delete' | 'merge' | 'restore';
// type RequestState = 'Requested' | 'Succeeded' | 'Failed' | null;
// type ActionCreatorKey = HTTPVerb | `${HTTPVerb}${RequestState}`;
// export type ActionCreators = {
//   [key in ActionCreatorKey]?: (payload?: any) => ReduxAction;
// };

// // object of action creators keyed by httpVerb + requestState. requestState is excluded for actions that can effect the
// // redux store immediately and may or may not have associated HTTP requests dispatched asyncronously
// export const requestActions = (
//   resourceType: string,
//   httpVerbs: Array<HTTPVerb> = ['fetchAll', 'fetch', 'create', 'update', 'delete', 'restore'],
// ): ActionCreators => {
//   return httpVerbs.reduce((actionCreators: ActionCreators, verb: HTTPVerb) => {
//     // "Requested" is included here for handling the case where a request is not dispatched immediately
//     // in response to an action, e.g. autosave
//     return ([null, 'Requested', 'Succeeded', 'Failed'] as RequestState[]).reduce(
//       (actionCreators: ActionCreators, requestState: RequestState) => {
//         const key: ActionCreatorKey = requestState ? `${verb}${requestState}` : verb;
//         const snakeCasedVerb = verb != 'fetchAll' ? verb : 'fetch_all';
//         let actionType = `${snakeCasedVerb.toUpperCase()}_${resourceType.toUpperCase()}`;

//         // pluralize resourceType for fetchAll action
//         if (verb == 'fetchAll' && !['ACTIVITY'].includes(resourceType)) {
//           actionType = `${actionType}S`;
//         }

//         if (requestState) {
//           actionType = `${actionType}_${requestState.toUpperCase()}`;
//         }

//         const action: ReduxAction = { type: actionType };

//         if (requestState == 'Failed') {
//           action.error = true;
//         }

//         actionCreators[key] = (payload: any) => ({ ...action, payload });

//         return actionCreators;
//       },
//       actionCreators,
//     );
//   }, {});
// };

// export const requestActions = (
//   resourceType: string,
//   httpVerbs: Array<HTTPVerb> = ['fetchAll', 'fetch', 'create', 'update', 'delete', 'restore'],
// ): ActionCreators => {
//   return httpVerbs.reduce((actionCreators: ActionCreators, verb: HTTPVerb) => {
//     // "Requested" is included here for handling the case where a request is not dispatched immediately
//     // in response to an action, e.g. autosave
//     return ([null, 'Requested', 'Succeeded', 'Failed'] as RequestState[]).reduce(
//       (actionCreators: ActionCreators, requestState: RequestState) => {
//         const key: ActionCreatorKey = requestState ? `${verb}${requestState}` : verb;
//         const snakeCasedVerb = verb != 'fetchAll' ? verb : 'fetch_all';
//         let actionType = `${snakeCasedVerb.toUpperCase()}_${resourceType.toUpperCase()}`;

//         // pluralize resourceType for fetchAll action
//         if (verb == 'fetchAll' && !['ACTIVITY'].includes(resourceType)) {
//           actionType = `${actionType}S`;
//         }

//         if (requestState) {
//           actionType = `${actionType}_${requestState.toUpperCase()}`;
//         }

//         const action: ReduxAction = { type: actionType };

//         if (requestState == 'Failed') {
//           action.error = true;
//         }

//         actionCreators[key] = (payload: any) => ({ ...action, payload });

//         return actionCreators;
//       },
//       actionCreators,
//     );
//   }, {});
// };
